import initialState from '../store/initial-state'
import {
  HOVER_MOUSE_ENTER,
  HOVER_MOUSE_LEAVE
} from '../constants/hover-vertical-types'

export default (state = initialState.hoverVerticalView, action) => {
  switch (action.type) {
    case HOVER_MOUSE_ENTER:
      return {
        hoverVerticalView: action.payload
      }

    case HOVER_MOUSE_LEAVE:
      return {
        hoverVerticalView: action.payload
      }

    default: return { ...state }
  }
}
